import React, { Component } from "react";
import { Table, Button, Col, Row, Tooltip } from "antd";
import axios from "axios";
import PrintModalCupom from '../components/PrintModalCupom';
import moment from "moment-timezone";
import numeral from "numeral";
import "./Relatorios.css";
import Colors from "../utils/Colors";
import { getUsuario } from "../utils/LoginManager";
import { maskCNPJ } from '../utils/Masker';

const { Column } = Table;

class PedidoPrintCupomModal extends Component {
    state = {
        registro: [],
        ven_idf: 0,
        ven_vlr_prod: 0,
        ven_vlr_desc: 0,
        ven_vlr_acres: 0,
        ven_vlr_total: 0,
        listaProdutos: [],
        listaParcelas: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if ((this.props.visivel !== propsAnte.visivel) && (this.props.ven_idf)) {
            this.setState({
                ven_idf: this.props.ven_idf,
                registro: [],
                visualizar: true,
            });
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });
        const { ven_idf } = this.props;

        axios
            .get(`/vendas/show/${ven_idf}`)
            .then(response => {
                const { data } = response;

                // console.log('PedidoPrintCupomModal - getListaRegistros: ', data);

                let ven_vlr_prod = 0;
                let ven_vlr_desc = 0;
                let ven_vlr_acres = 0;
                let ven_vlr_total = 0;
                for (var x in data.listaProdutos) {
                    ven_vlr_prod = ven_vlr_prod + parseFloat(data.listaProdutos[x].mi_vlr_unit);
                    ven_vlr_desc = ven_vlr_desc + parseFloat(data.listaProdutos[x].mi_vlr_desc);
                    ven_vlr_acres = ven_vlr_acres + parseFloat(data.listaProdutos[x].mi_vlr_acres);
                    ven_vlr_total = ven_vlr_total + parseFloat(data.listaProdutos[x].mi_vlr_total);
                };

                this.setState({
                    registro: data.dados,
                    listaProdutos: data.listaProdutos,
                    listaParcelas: data.listaParcelas,
                    ven_vlr_prod,
                    ven_vlr_desc,
                    ven_vlr_acres,
                    ven_vlr_total,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            ven_idf: 0,
            registro: [],
            visualizar: false,
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true,
        })
    }

    renderValor = (ven_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span>-</span>
        }
    }

    renderDataParc = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span>-</span>
        }
    }


    renderProdutos = () => {
        const zeroPad = (num, places) => String(num).padStart(places, '0');
        // console.log('renderProdutos listaRegistros: ', this.state.listaProdutos);

        const content = this.state.listaProdutos.map((post, index) =>
            <Col xs={24}  >
                <div style={{ color: "black" }}>
                    <Col xs={6} style={{ fontSize: 10, textAlign: "left" }} >
                        <span>{zeroPad(post.prod_codigo, 6)}</span>
                    </Col>
                    <Col xs={6} style={{ fontSize: 10, textAlign: "right" }} >
                        <span>{this.renderValor(post.mi_qtde)}</span>
                    </Col>
                    <Col xs={6} style={{ fontSize: 10, textAlign: "right" }} >
                        <span>{this.renderValor(post.mi_vlr_unit)}</span>
                    </Col>
                    <Col xs={6} style={{ fontSize: 10, textAlign: "right" }} >
                        <span>{this.renderValor(post.mi_vlr_total)}</span>
                    </Col>
                    <Col xs={24} style={{ fontSize: 10, height: 22, textAlign: "left" }} >
                        <span>{post.prod_descricao}</span>
                    </Col>
                </div>
            </Col>
        );

        return (
            <div style={{ color: "black" }}>
                <Col xs={6} style={{ fontSize: 11, textAlign: "left" }} >
                    <span style={{ fontWeight: "bold" }}>Codigo </span>
                </Col>
                <Col xs={6} style={{ fontSize: 11, textAlign: "right" }} >
                    <span style={{ fontWeight: "bold" }}>Qtde </span>
                </Col>
                <Col xs={6} style={{ fontSize: 11, textAlign: "right" }} >
                    <span style={{ fontWeight: "bold" }}>Preço </span>
                </Col>
                <Col xs={6} style={{ fontSize: 11, textAlign: "right" }} >
                    <span style={{ fontWeight: "bold" }}>Total </span>
                </Col>
                <Col xs={24} style={{ fontSize: 11, textAlign: "left" }} >
                    <span style={{ fontWeight: "bold" }}>Descrição </span>
                </Col>
                <Col xs={24} style={{ fontSize: 11, textAlign: "left" }} >
                    <div style={{ marginTop: 5, height: 1, backgroundColor: Colors.background }} />
                </Col>
                {content}
            </div>
        );

    };

    renderPagamentos = () => {
        const zeroPad = (num, places) => String(num).padStart(places, '0');
        // console.log('renderPagamentos listaRegistros: ', this.state.listaProdutos);

        const content = this.state.listaParcelas.map((post, index) =>
            <Col xs={24}  >
                <div style={{ color: "black" }}>
                    <Col xs={6} style={{ fontSize: 10, textAlign: "left" }} >
                        <span>{zeroPad(post.tparc_parcela, 3)}</span>
                    </Col>
                    <Col xs={6} style={{ fontSize: 10, textAlign: "left" }} >
                        <span>{this.renderDataParc(post.tparc_data_parcela)}</span>
                    </Col>
                    <Col xs={6} style={{ fontSize: 10, textAlign: "right" }} >
                        <span>{this.renderValor(post.tparc_valor)}</span>
                    </Col>
                    <Col xs={6} style={{ fontSize: 10, textAlign: "center" }} >
                        <span>{post.situacao_parcela}</span>
                    </Col>
                </div>
            </Col>
        );

        return (
            <div style={{ color: "black" }}>
                <Col xs={6} style={{ fontSize: 11, textAlign: "left" }} >
                    <span style={{ fontWeight: "bold" }}>Parcela </span>
                </Col>
                <Col xs={6} style={{ fontSize: 11, textAlign: "left" }} >
                    <span style={{ fontWeight: "bold" }}>Data </span>
                </Col>
                <Col xs={6} style={{ fontSize: 11, textAlign: "right" }} >
                    <span style={{ fontWeight: "bold" }}>Valor </span>
                </Col>
                <Col xs={6} style={{ fontSize: 11, textAlign: "center" }} >
                    <span style={{ fontWeight: "bold" }}> </span>
                </Col>
                {content}
            </div>
        );

    };

    render() {
        const { onCancelarPrintClick, visivel } = this.props;
        const { carregando, visualizar, listaProdutos, listaParcelas } = this.state;
        const { ven_numero, ven_dt_venda, ven_pessoa, pes_nome, usu_nome, ven_vlr_desc_venda,
            cp_descricao, ven_obs, pes_fone1, pes_fone2, pes_fone3,
            pes_endereco, pes_numero, pes_bairro, pes_cep, cmun_descricao, cuf_sigla } = this.state.registro;

        // console.log('PedidoPrintCupomModal: ', this.state);

        const usuario = getUsuario();
        const zeroPad = (num, places) => String(num).padStart(places, '0');

        return (
            <span style={{}}>
                <PrintModalCupom
                    visible={visivel}
                    onCancel={onCancelarPrintClick}
                >

                    <div style={{}}>
                        <div className="titulo1" style={{ marginTop: 0, marginLeft: 0 }}>
                            <div>
                                <span style={{ fontSize: 12, fontWeight: 'bold' }}>
                                    {usuario.emp_nome}
                                </span>
                            </div>
                            <div style={{ fontSize: 8 }}>
                                <span style={{}}>
                                    {usuario.emp_cpf_cnpj ? maskCNPJ(usuario.emp_cpf_cnpj) : ''}
                                    {usuario.emp_fone1 ? ' - ' + usuario.emp_fone1 : ''}
                                    {usuario.emp_fone2 ? ' - ' + usuario.emp_fone2 : ''}
                                    {usuario.emp_fone3 ? ' - ' + usuario.emp_fone3 : ''}
                                </span>
                            </div>
                            <div style={{ fontSize: 8 }}>
                                <span style={{}}>
                                    {usuario.emp_endereco ? usuario.emp_endereco : ''}
                                    {usuario.emp_numero ? ' nº ' + usuario.emp_numero : ''}
                                    {usuario.emp_complemento ? ' ' + usuario.emp_complemento : ''}
                                    {usuario.emp_bairro ? ' - ' + usuario.emp_bairro : ''}
                                    {usuario.cmun_descricao ? ' - ' + usuario.cmun_descricao : ''}
                                    {usuario.cuf_sigla ? ' - ' + usuario.cuf_sigla : ''}
                                </span>
                            </div>
                        </div>

                        <div style={{ marginTop: 5, height: 2, backgroundColor: "black" }} />

                        <Row>
                            <div style={{ float: "right", marginTop: 0, marginRight: 0, color: "black" }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10 }}>{zeroPad(ven_numero, 6)}</span>
                            </div>
                            <div style={{ float: "left", marginTop: 0, marginLeft: 0, color: "black" }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10 }}>Data: </span>
                                <span style={{ fontSize: 10 }}> {this.renderData(ven_dt_venda)} </span>
                            </div>
                        </Row>

                        <Row className="titulo1" style={{ fontSize: 12, fontWeight: 'bold' }}>
                            COMPROVANTE DE VENDA
                        </Row>

                        <div style={{ marginTop: 5, height: 2, backgroundColor: "black" }} />

                        <Row style={{}}>
                            {this.renderProdutos()}
                        </Row>

                        <div style={{ marginTop: 5, height: 2, backgroundColor: "black" }} />

                        <Row>
                            <div style={{ float: "right", marginTop: 0, marginRight: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>{this.renderValor(this.state.ven_vlr_prod)}</span>
                            </div>
                            <div style={{ float: "left", marginTop: 0, marginLeft: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>TOTAL DOS ITENS: </span>
                            </div>
                        </Row>
                        <Row>
                            <div style={{ float: "right", marginTop: 0, marginRight: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>{this.renderValor(this.state.ven_vlr_desc + ven_vlr_desc_venda)}</span>
                            </div>
                            <div style={{ float: "left", marginTop: 0, marginLeft: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>DESCONTOS: </span>
                            </div>
                        </Row>
                        <Row>
                            <div style={{ float: "right", marginTop: 0, marginRight: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>{this.renderValor(this.state.ven_vlr_acres)}</span>
                            </div>
                            <div style={{ float: "left", marginTop: 0, marginLeft: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 10, color: "black" }}>TAXAS: </span>
                            </div>
                        </Row>
                        <Row>
                            <div style={{ float: "right", marginTop: 0, marginRight: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 11, color: "black" }}>{this.renderValor(this.state.ven_vlr_total - ven_vlr_desc_venda)}</span>
                            </div>
                            <div style={{ float: "left", marginTop: 0, marginLeft: 0 }}>
                                <span style={{ fontWeight: 'bold', fontSize: 11, color: "black" }}>TOTAL GERAL: </span>
                            </div>
                        </Row>

                        <div style={{ marginTop: 5, height: 2, backgroundColor: "black" }} />

                        <Row style={{ marginLeft: 0, marginTop: 10, color: "black" }}>
                            <Col xs={24} style={{ marginTop: 0, fontSize: 9 }} >
                                <span style={{ fontWeight: 'bold' }}>Vendedor: </span>
                                <span> {usu_nome} </span>
                            </Col>
                            <Col xs={24} style={{ marginTop: 0, fontSize: 9 }} >
                                <span style={{ fontWeight: 'bold' }}>Cliente: </span>
                                <span> {ven_pessoa + ' - ' + pes_nome} </span>
                            </Col>
                            {(pes_fone1 !== '' || pes_fone2 !== '' || pes_fone3 !== '') && (pes_fone1 !== '(  )      -' || pes_fone2 !== '(  )      -' || pes_fone3 !== '(  )      -') ? (
                                <Col xs={24} style={{ marginTop: 0, fontSize: 9 }} >
                                    <span style={{ fontWeight: 'bold' }}>Fones: </span>
                                    <span> {pes_fone1 !== '' && pes_fone1 !== '(  )      -' ? ' - ' + pes_fone1 : ''} </span>
                                    <span> {pes_fone2 !== '' && pes_fone2 !== '(  )      -' ? ' - ' + pes_fone2 : ''} </span>
                                    <span> {pes_fone3 !== '' && pes_fone3 !== '(  )      -' ? ' - ' + pes_fone3 : ''} </span>
                                </Col>
                            ) : null}
                            <Col xs={24} style={{ marginTop: 0, marginBottom: 10, fontSize: 9 }} >
                                <span style={{ fontWeight: 'bold' }}>Endereço: </span>
                                <span> {pes_endereco ? pes_endereco : ''} </span>
                                <span> {pes_numero ? ' - ' + pes_numero : ''} </span>
                                <span> {pes_bairro ? ' - ' + pes_bairro : ''} </span>
                                <span> {pes_cep ? ' - ' + pes_cep : ''} </span>
                                <span> {cmun_descricao ? ' - ' + cmun_descricao : ''} </span>
                                <span> {cuf_sigla ? ' - ' + cuf_sigla : ''} </span>
                            </Col>
                            {ven_obs ? (
                                <Col xs={24} style={{ marginTop: 0, fontSize: 9 }} >
                                    <span style={{ fontWeight: 'bold' }}>OBS: </span>
                                    <span> {ven_obs} </span>
                                </Col>
                            ) : null}
                        </Row>

                        <div style={{ marginTop: 5, height: 1, backgroundColor: "black" }} />

                        {listaParcelas && listaParcelas.length > 0 ? (
                            <Row style={{ marginTop: 10, marginBottom: 20, fontSize: 12, color: "black" }}>
                                <span style={{ fontWeight: 'bold' }}>PAGAMENTO - {cp_descricao}</span>
                                {this.renderPagamentos()}
                            </Row>
                        ) : null}

                        <Row className="titulo1" style={{ marginTop: 50, marginBottom: 30, fontSize: 10, color: "black" }} >
                            <Col xs={24} style={{ fontWeight: 'bold' }} >
                                <span>-----------------------------</span>
                            </Col>
                            <Col xs={24} style={{ fontWeight: 'bold' }} >
                                <span>ASSINATURA DO CLIENTE</span>
                            </Col>
                            <Col xs={24} style={{ marginTop: 30, fontSize: 10 }} >
                                <span>Este cupom não é documento fiscal</span>
                            </Col>
                            <Col xs={24} style={{ fontSize: 10 }} >
                                <span>Desenvolvido por</span>
                                <span style={{ fontWeight: 'bold' }}> Plena Sistemas</span>
                            </Col>
                        </Row>


                    </div>

                </PrintModalCupom>
            </span>
        );
    }
}

export default PedidoPrintCupomModal;



// WEBPACK FOOTER //
// ./src/relatorios/PedidoPrintCupomModal.js